import Vue from 'vue'
import VueResource from 'vue-resource'
import { VueConstructor } from 'vue/types/umd'

Vue.use(VueResource)

export function use(Vue: VueConstructor): void {
  Vue.use(VueResource)
}
